import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

import "../../css/template/elements.css"
import "../../css/blocks/mkl.css"


export default class extends Controller {
    connect() {


        $.ajax({
            type: "get",
            url: 'https://api.actualoptic.kz:8443/cabinet/lens/'+ usertoken,
            contentType: "application/json",
            acync: false,
            success: function(data){
                console.debug(data);
                data.forEach((item)=>{
                    let salesDate = new Date(item.sales_date).toLocaleDateString('ru-KZ');
                    if (salesDate === '01.01.1') {
                        salesDate = 'неизвестно'
                    }

                    let expirationDate = new Date(item.expiration_date).toLocaleDateString('ru-KZ');
                    console.debug(expirationDate);
                    if (expirationDate === '01.01.1') {
                        expirationDate = 'неизвестно'
                    }

                    //проверяем есть ли ID товара
                    let productLink;
                    if(item.product_id === null){
                        productLink = 'https://api.whatsapp.com/send?phone=77753750502&amp;text=Хочу заказать '+item.product_name;
                    } else {
                        productLink = 'https://shop.actualoptic.kz/index.php?route=product/product&product_id='+item.product_id
                    }

                $('#mklGenList').append('' +
                    '<ul class="mkl__list">\n' +
                    '   <li class="mkl_name">\n' +
                    '       <strong class="mkl_name-title">'+item.product_name+'</strong>\n' +
                    '   </li>\n' +
                    '   <li class="mkl_sales-date"><span class="mkl__titleMob">Дата покупки</span>'+ salesDate +
                    '</li>\n' +
                    '\n' +
                    '   <li class="mkl_expiration-date"><span class="mkl__titleMob">Дата замены</span>'+ expirationDate +'</li>\n' +
                    '\n' +
                    '   <li class="mkl_qty"><span class="mkl__titleMob">Количество</span>'+item.qty+'</li>\n' +
                    '   <li class="mkl_link">\n' +
                    '   <a class="btn" href="'+productLink+'">Повторить заказ</a>\n' +
                    '   </li>\n' +
                    '</ul>')
                    });
             },
            error(error){
                console.debug(error);
                //window.location.replace("404.html");
            }
        });


    }
}
